import React from 'react';
import manifestoimg from './assets/manifesto.png';

function ProjectContact() {
  return (
    <div>
      <h2>manifesto</h2>
      <a 
        href="https://ordiscan.com/inscription/76070638" 
        style={{ 
          color: 'rgb(170, 170, 170)', 
          textDecoration: 'underline', 
          fontStyle: 'italic' 
        }} 
        target="_blank" 
        rel="noopener noreferrer"
      >
        #76,070,638
      </a>
      <div style={{ marginTop: '10px' }}>
        <img 
          src={manifestoimg} 
          alt="Manifesto" 
          style={{ 
            width: '100%', 
            maxWidth: 620, 
            display: 'block', 
            height: 'auto'
          }} 
        />
      </div>
    </div>
  );
}

export default ProjectContact; 